// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"c9b8ab34","224":"a42e4b3b","777":"9aeb2640"}[chunkId] + ".chunk.css";
};